module.exports = __webpack_public_path__ + "img/cnbv.9acaae9e.png";